import boy1 from "../images/boy1.png";
import boy2 from "../images/boy2.png";
import boy3 from "../images/boy3.png";
import girl1 from "../images/girl1.png";
import girl2 from "../images/girl2.png";
import girl3 from "../images/girl3.png";

export const imagesList = {
  boy1,
  boy2,
  boy3,
  girl1,
  girl2,
  girl3,
};
